import { formatDateToMMDDYYYY } from 'shared/utils/dates/formatDate';

type ImageOverlay = {
    imageData: string;
    position: { x: number; y: number;  width?: number; height?: number; };
    pageNum?: number;
}; 

interface GenerateDirectDepositPDFParams {
	formik: any; // You can replace 'any' with a more specific type if you have one
	employeeSignatureFile?: File | null;
	workplaceName: string;
	organizationName: string;
	employeeEmail: string,
	imageOverlays: ImageOverlay[];
}


// Import your existing PDF generation function
import { generateAndDownloadPDF } from "./pdfUtils"; 

export const handleDirectDepositPDFGeneration = async ({
	formik,
	employeeSignatureFile,
	workplaceName,
	organizationName,
	employeeEmail,
	imageOverlays
}: GenerateDirectDepositPDFParams): Promise<void> => {
	try {
		const now = new Date().toISOString().split('T')[0];
		// Step 1: Prepare Text Fields
		const textFields = {
			"to send credit entries and appropriate debit and adjustment entries electronically or by any other commercially accepted method to":
			  formik.values.restaurant_name,
			"Employee Bank Name": formik.values.bank_name,
			"Bank Routing  ABA": formik.values.routing_number,
			"Account": formik.values.account_number,
			"Percentage or Dollar Amount to be Deposited to This Account": "",
			// "Employee Bank Name_2": formik.values.bank_name,
			// "Bank Routing ABA_2": "222000033 - 007",
			// "Account_2": "0987654321 - 008",
			"Printed Name": formik.values.first_name + " " + formik.values.last_name,
			// "Employee ID": "EMP999888 - 010",
			"Date": formatDateToMMDDYYYY(now),
			// "Attach a Voided Check": "Voided check attached - 012"
		  };

		const checkboxes = [];
		if(String(formik.values?.account_type) == "1") {checkboxes.push("Checking");}
		if(String(formik.values?.account_type) == "2") {checkboxes.push("Savings");}	

		const signatures = [];
		if (employeeSignatureFile || formik.values.internal_signature_file) {
			signatures.push(
				{
					file: employeeSignatureFile || (process.env.REACT_APP_URL + formik.values.internal_signature_file),
					position: {'x': 105, 'y':192 , 'width': 100, 'height': 23},
					pageNum: 0,
				}
			);
		}
		
		const textOverlays = [];

		// Step 5: Build filename prefix
		const filePrefix = `DirectDeposit_${formik.values?.last_name}_${formik.values?.first_name}`;

		// Step 6: Generate the filled PDF
		await generateAndDownloadPDF(
			"/Direct_deposit.pdf",
			textFields,
			{},
			checkboxes,
			filePrefix,
			workplaceName,
			organizationName,
			employeeEmail,
			formik?.values.id,
			signatures,
			undefined, // textOverlays
			undefined, // radioGroupMappings
			imageOverlays // ✅ correct way to pass it
		);

	} catch (error) {
		console.error("Error generating I-9 PDF:", error);
	}
};